import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes"
import { apiError, loginSuccess, logoutUserSuccess } from "./actions"

import * as backend from "helpers/backend"
import { setAuthToken } from "helpers/api_helper"
import { validateAdminLoginResponse } from "helpers/admin_session_helper"

export function* loginUser({ payload: { user, history } }) {
  try {
    localStorage.removeItem("cmsAuth")
    localStorage.removeItem("authUser")
    setAuthToken(null)
    const response = yield call(backend.login, {
      username: user.username,
      password: user.password,
    })

    const token = validateAdminLoginResponse(response)
    localStorage.setItem("cmsAuth", token)
    setAuthToken(token)
    yield put(loginSuccess(response))

    window.location = "/dashboard"
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "Unable to connect to the API"

    yield put(apiError(errorMessage))
  }
}

export function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("cmsAuth")
    localStorage.removeItem("authUser")
    setAuthToken(null)
    yield put(logoutUserSuccess())
    history("/login")
  } catch (error) {
    yield put(apiError(error))
  }
}

// function* socialLogin({ payload: { type, history } }) {
//   try {
//     if (process.env.DEFAULTAUTH === "firebase") {
//       const fireBaseBackend = getFirebaseBackend();
//       const response = yield call(fireBaseBackend.socialLoginUser, type);
//       if (response) {
//         history("/dashboard");
//       } else {
//         history("/login");
//       }
//       localStorage.setItem("authUser", JSON.stringify(response));
//       yield put(loginSuccess(response));
//     }
//     if(response)
//     history("/dashboard");
//   } catch (error) {
//     yield put(apiError(error));
//   }
// }

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  // yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser)
}

export default authSaga
